module.exports = __webpack_public_path__ + "static/media/Vigen_Coromoto_Altar_Mayor_small.755633c8.jpg";